module.exports = __webpack_public_path__ + "static/media/sun.f2a2a1b2.png";